import { render, staticRenderFns } from "./SendData.vue?vue&type=template&id=d80918f8&"
import script from "./SendData.vue?vue&type=script&lang=js&"
export * from "./SendData.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/physicalShop/snappay/snappayStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports